import Navbar from "../../components/Navbar";
import Footer from "./sections/Footer";
import { articles } from "./Articles";

const ArticlesPage = () => {
  const mainArticle = articles[0];
  const leftArticles = articles.slice(1, 4);
  const latestArticles = articles.slice(4);

  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <section className="py-32 bg-gradient-to-b from-secondary_1 via-white to-white border-b">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <span className="inline-block mb-6 px-4 py-1 rounded-full bg-orange-100 text-orange-600 text-sm font-medium">
            مقالات بامیزبان
          </span>

          <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-6">
            نکات و راهنمایی‌های حرفه‌ای
            <br />
            <span className="text-orange-500">برای مدیریت رستوران‌ها و افزایش فروش</span>
          </h1>

          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            مقالات آموزشی، راهنمایی‌ها و تجربیات کاربردی برای بهبود تجربه مشتری و مدیریت حرفه‌ای منو
          </p>
        </div>
      </section>

      <main className="bg-white text-gray-900">

        {/* مقالات پر بازدید */}
        <section className="py-24 bg-gray-50">
          <div className="max-w-6xl mx-auto px-6 space-y-12">
            <h2 className="text-3xl font-bold text-gray-800">مقالات پر بازدید</h2>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

              {/* کارت اصلی */}
              <div className="md:col-span-2">
                <div className="relative bg-white rounded-3xl shadow-lg overflow-hidden group cursor-pointer transition-all duration-300">
                  <img
                    src={mainArticle.image}
                    alt={mainArticle.title}
                    className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                  <div className="p-8 relative">
                    <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">{mainArticle.title}</h2>
                    <p className="text-gray-600 line-clamp-3">{mainArticle.summary}</p>
                    <div className="mt-4 flex flex-wrap gap-2">
                      {mainArticle.tags.map((tag, idx) => (
                        <span key={idx} className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-xs">{tag}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* کارت‌های کوچک */}
              <div className="md:col-span-2 grid grid-cols-1 gap-6">
                {leftArticles.map((item) => (
                  <div key={item.id} className="bg-white rounded-3xl shadow-md hover:shadow-lg transition-all duration-300 flex flex-row gap-4 p-4 cursor-pointer">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-28 h-28 object-cover rounded-2xl flex-shrink-0 transform transition-transform duration-300 hover:scale-105"
                    />
                    <div className="flex-1 flex flex-col justify-between">
                      <div>
                        <h3 className="text-lg md:text-xl font-semibold text-gray-900">{item.title}</h3>
                        <p className="text-gray-600 text-sm mt-1 line-clamp-3">{item.summary}</p>
                      </div>
                      <div className="mt-2 flex flex-wrap justify-between items-center text-xs text-gray-500 gap-2">
                        <span>نویسنده: {item.author}</span>
                        <span>{item.date}</span>
                        <div className="flex flex-wrap gap-2">
                          {item.tags.map((tag, idx) => (
                            <span key={idx} className="px-2 py-1 bg-gray-100 rounded-full">{tag}</span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </section>



        {/* آخرین مقالات */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-6xl mx-auto px-6 space-y-8">
            <h2 className="text-3xl font-semibold text-gray-800">آخرین مقالات</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
              {latestArticles.map((item) => (
                <div key={item.id} className="bg-white p-4 rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer">
                  <img src={item.image} className="w-full h-36 md:h-40 object-cover rounded-xl" alt={item.title} />
                  <h3 className="text-lg md:text-xl font-semibold mt-3 text-gray-900">{item.title}</h3>
                  <p className="text-gray-600 text-sm mt-1 leading-relaxed">{item.summary}</p>
                  <div className="mt-2 flex flex-wrap gap-2 text-xs text-gray-500">
                    {item.tags.map((tag, idx) => (
                      <span key={idx} className="px-2 py-1 bg-gray-100 rounded-full">{tag}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
{/* مقالات پیشنهادی */}
<section className="py-24">
  <div className="max-w-6xl mx-auto px-6 space-y-8">
    <h2 className="text-3xl font-bold text-gray-800">مقالات پیشنهادی</h2>
    <p className="text-gray-600 max-w-2xl">
      این مقالات براساس علاقه کاربران و پر بازدیدترین‌ها برای شما انتخاب شده‌اند.
    </p>

    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
      {latestArticles.map((item) => (
        <div key={item.id} className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer flex flex-col">
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-36 object-cover rounded-t-2xl transition-transform duration-300 hover:scale-105"
          />
          <div className="p-4 flex-1 flex flex-col justify-between">
            <h3 className="text-md md:text-lg font-semibold text-gray-900 mb-2 line-clamp-2">{item.title}</h3>
            <p className="text-gray-500 text-sm mb-2 line-clamp-3">{item.summary}</p>
            <div className="flex flex-wrap gap-2 text-xs text-gray-500">
              {item.tags.map((tag, idx) => (
                <span key={idx} className="px-2 py-1 bg-gray-100 rounded-full">{tag}</span>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      </main>
      <Footer />
    </>
  );
};

export default ArticlesPage;
